import MsalMainLayout from './MsalMainLayout';

export default MsalMainLayout;
